import { Group, Visibility } from './group.model'
import { User } from './user.model'

export interface IGroupRequestData {
  id: string,
  authorId?: string,
  name?: string,
  description?: string,
  visibility?: string,
  usersIds?: Array<string>
  userId?: string
}

export class GroupForm {
  public id: string
  public author: User
  public name: string
  public description: string
  public visibility: string
  public users: User[]

  fill (group: Group) {
    this.id = group.id
    this.author = group.author
    this.name = group.name
    this.description = group.description
    this.visibility = Visibility[group.visibility]
    this.users = group.users
  }

  update (group: Group) {
    group.id = this.id
    group.author = this.author
    group.name = this.name
    group.description = this.description
    group.visibility = Visibility[this.visibility]
    group.users = this.users
  }

  toRequestData (): IGroupRequestData {
    return {
      id: this.id,
      authorId: this.author.id,
      name: this.name,
      description: this.description,
      visibility: this.visibility,
      usersIds: this.users.map((user) => user.id)
    }
  }

  isPrivate () {
    return this.visibility === Visibility[Visibility.private]
  }

  toggleVisibility () {
    this.visibility = this.visibility === Visibility[Visibility.private]
      ? Visibility[Visibility.public]
      : Visibility[Visibility.private]
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/models/group-form.model.ts